<script lang="ts">
  import { onMount } from "svelte"
  import { Pulse } from "svelte-loading-spinners"
  import { MessageSquare } from "lucide-svelte"
  import Progress from "./Progress.svelte"
  import Form from "./Form.svelte"
  import { xhr, toast } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import { appStore } from "$app/store.svelte"

  const plan: PlanType = appStore.plan
  interface Props {
    id: number
    type?: string
  }

  let { id, type = "goal" }: Props = $props()

  let progresses: ProgressType[] = $state([])
  let avatarUrl = null
  let userName = ""

  let loading = $state(true)

  let url = $derived(type === "goal" ? "goal_progress" : "task_progress")

  async function getProgresses() {
    try {
      const resp = await xhr.get(`/plans/${appStore.plan.id}/${url}?id=${id}`)

      progresses = resp.data.progresses.map((p: any) => {
        return { ...p, edit: false }
      })
      avatarUrl = resp.data.avatar_thumb_url
      userName = resp.data.user_name
    } catch (e) {
      if (typeof Honeybadger.notify !== "undefined") {
        Honeybadger.notify(e)
      }
      toast("There was an error loading the progresses", "error")
    } finally {
      progresses = progresses
      avatarUrl = avatarUrl
      userName = userName
      loading = false
    }
  }

  // Create progress report
  let progressBtnEnabled = $state(false)
  let newProgress = $state(false)

  onMount(async () => {
    getProgresses()
  })
</script>

<h3 class="flex items-center mb-1">
  <MessageSquare class="text-gray-400 mr-2" />
  Progress
  {#if !newProgress}
    <button
      data-name="new-goal-progress"
      class="px-4 ml-4 bg-gray-50 border border-gray-200 text-gray-800 hover:bg-gray-100 rounded-sm shadow-sm text-xs py-1"
      onclick={() => {
        newProgress = true
        progressBtnEnabled = false
      }}
    >
      + Add Progress
    </button>
  {/if}
</h3>

{#if newProgress}
  <Form
    progress={{ plan_id: plan.id, [`${type}_id`]: id }}
    {type}
    operation="create"
    oncreate={(data) => {
      progresses = [data, ...progresses]
      newProgress = false
      toast("Progress added", "success")
    }}
    oncancel={() => {
      newProgress = false
    }}
  />
{/if}

<div class="overflow-y-auto pr-6" data-name="progresses">
  {#if loading}
    <div class="py-12 flex justify-center w-full">
      <Pulse size="240" color="#cdcdcd" unit="px" duration="1s" />
    </div>
  {:else}
    {#each progresses as progress (progress.id)}
      {#if progress.edit}
        <Form
          {progress}
          {type}
          onupdate={(data) => {
            progresses = progresses.map((p) => {
              if (p.id === progress.id) {
                return { ...p, ...data, edit: false }
              }
              return p
            })

            toast("Progress updated", "success")
          }}
          oncancel={() => {
            progress.edit = false
          }}
        />
      {:else}
        <Progress
          {progress}
          {type}
          onedit={() => {
            progress.edit = true
          }}
          ondelete={() => {
            progresses = progresses.filter((d) => d.id !== progress.id)
            toast("Progress deleted", "success")
          }}
        />
      {/if}
    {:else}
      {#if !newProgress}
        <div
          class="text-center text-gray-600 mt-4 border border-gray-200 bg-gray-50 rounded p-2"
        >
          No progress yet
        </div>
      {/if}
    {/each}
  {/if}
</div>
